//export class Questionnaire {
//    question: string = '';
//    answer: string = '';
//}

/*
export class CovidQuestionnaireInput {    
    questionnaireList = [];
    ldc: string = '';
    kmiUrlCode: string = '';
    orderNumber: string = '';
    orderType: string = '';
    premisesNumber: string = '';    
    logReferenceID: string = '';
    portalTypeID: number = 0;    
    emailToList: string = '';
}
export class CovidQuestionnaireOutput {
    isQuestionnaireHasYes: boolean = false;
    questionnaireQnAnswerList = [];
}
*/

export class AccountVerificationInput {    
    ldc: string = '';
    cisOrderType: string = '';
    acntNumberFromURL: string = '';
    logReferenceID: string = '';
    portalTypeID: number = 0;
    emailToList: string = '';
    contactPhoneNo: string = '';
    contactHours: string = '';
}
export class AccountVerificationOutput {
    accountDetails: AccountDetails;
    accountNumber: string = '';
}

export class AccountDetails {
    isValidAccount: boolean = false;
    isOrderEligibleToSchedule: boolean = false;
    orderNumber: string = '';
    premiseNumber: string = '';
    personID: string = '';
    ldc: string = '';
    serviceCenter: string = '';
    billingAddress: string = '';
    premisesAddress: string = '';
    customerName: string = '';
    customerFirstName: string = '';
    emailAddress: string = '';
    phoneNumber: string = '';
    premiseType: string = '';
    isKMIEligible: boolean = false;
    marketerName: string = '';
    marketerPhoneNumber: string = '';
}